import { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AboutDoctor from "./components/Aboutdoctor";
import Services from "./components/Services";
import TrustHighlights from "./components/Trusthighlights";
import PatientJourney from "./components/Patientjourney";
import OurTeam from "./components/Ourteam";
import Testimonials from "./components/Testimonials";
import Contact from "./components/contact";
import Footer from "./components/Footer";
import AdminLogin from "./admin/Adminlogin";
import AdminDashboard from "./admin/Admindashboard";
import "./App.css";

export default function App() {
  const [page, setPage]         = useState("home");
  const [adminAuth, setAdminAuth] = useState(false);

  useEffect(() => {
    const checkRoute = () => {
      if (window.location.hash === "#/admin") setPage("admin");
      else setPage("home");
    };
    checkRoute();
    window.addEventListener("hashchange", checkRoute);
    return () => window.removeEventListener("hashchange", checkRoute);
  }, []);

  if (page === "admin") {
    if (!adminAuth) return <AdminLogin onLogin={() => setAdminAuth(true)} />;
    return (
      <AdminDashboard
        onLogout={() => {  localStorage.removeItem("adminToken"); setAdminAuth(false); window.location.hash = ""; }}
      />
    );
  }

  return (
    <div className="app">
      <Navbar />
      <Hero />
      <AboutDoctor />
      <Services />
      <TrustHighlights />
      <PatientJourney />
      <OurTeam />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}